import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import Mic from "@mui/icons-material/Mic";
import MicOff from "@mui/icons-material/MicOff";
import PhoneIcon from "@mui/icons-material/Phone";
import PhonePaused from "@mui/icons-material/PhonePaused";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import "./CallOverlay.css";

const CallOverlay = () => {
  const [isShown, setIsShown] = useState(false);
  const [icon, setIcon] = useState("");
  const [text, setText] = useState("");

  const { isInCall, isMuted, onHold, startNextAssignment, type } = useSelector(
    (state) => state.call
  );

  /* To show/hide overlay */
  useEffect(() => {
    if (isInCall || startNextAssignment) {
      // Show, then hide after 2 seconds
      setIsShown(true);

      const timeout = setTimeout(() => {
        setIsShown(false);
      }, 2000);

      return () => {
        clearTimeout(timeout);
        setIsShown(false);
      };
    }
  }, [isInCall, isMuted, onHold, startNextAssignment]);

  /* Set icon and text according to each event (call, mute, hold, next assignment) */
  useEffect(() => {
    // Don't show overlay if call type is inbound
    if (type === "inbound") {
      setIsShown(false);
      setIcon("");
      setText("");
    }

    // Don't show when starting next assignment (Next assignment icon is already shown)
    if (!startNextAssignment) {
      setIcon(<WifiCalling3Icon />);
      setText("Dialing");
    }
  }, [isInCall]);

  useEffect(() => {
    if (isMuted) {
      setIcon(<MicOff />);
      setText("Muted");
    } else {
      setIcon(<Mic />);
      setText("Unmuted");
    }
  }, [isMuted]);

  useEffect(() => {
    if (onHold) {
      setIcon(<PhonePaused />);
      setText("On-hold");
    } else {
      setIcon(<PhoneIcon />);
      setText("Resume");
    }
  }, [onHold]);

  useEffect(() => {
    setIcon(<Icon height="161" icon="fa6-solid:user-group" />);

    setText("Next Assignment");
  }, [startNextAssignment]);

  return (
    <div className={`call-overlay ${isShown ? "shown" : ""}`}>
      <div className="overlay-icon">{icon}</div>
      <span className="overlay-text">{text}</span>
    </div>
  );
};

export default CallOverlay;
